import { get, post, uploadSplice,frontDeskPost} from '@/services/axios'
import { UserInfo } from '@/store/modules/user/state'
import portalHttp from '@/services/portal/request'

// 院系tree
export interface FacultyTree {
	check?: 0 | 1,
	icon: string,
	id: string,
	pid: string,
	text: string,
	children?: FacultyTree[]
}

// 分片上传接口
export const onUploadSplice = (params: FormData) => {
	return uploadSplice<{ code: number, data: any, message: string, status: 1 | 2, }>('/Portal/Index/upload', params);
}
// 用户信息
export const getUserInfo = () => {
	//return get<any>('/moocapi/user/infor' );
	
	return get('/Portal/Index/getUserInfo')
}

// 获取用户信息
export const getPortalInfo = () => {
	
	return portalHttp.get<UserInfo>('/Portal/NoAuth/getUserInfo')
}

//获取院系共用接口
export const getAuthTreeList = () => {
	
	return post<FacultyTree[]>('/AuthManageApi/authTreeList',{})
}
//获取所有数据平台列表
export const getExternalLists = (params:any) => {
	
	return post('/bigdata/performance/externalLists',params)
}

//获取学期管理列表共用接口
export const getSemesterList = () => {
	
	return post('/bigdata/dashboards/listsSemester',{})
}

// 判断机构是否付费
export const isVip = ()=> {
	
    return post<{ isVip: number, info: string}>('/VipApi/isVip',{})
}

//机构登录
export const systemLogin = (params: { email: string, password: string, remember: string})=> {
    return post('/UserApi/login',params,{showErr:false})
}
//获取登录二维码
export const getWechatCode = ()=> {
    return frontDeskPost('/wechat/mp/pa/qrcode/auth/create') //前台接口
}
//获取二维码登录状态
export const getWechatCodeState = (params: { qr_id: string})=> {
    return frontDeskPost('/wechat/mp/pa/qrcode/auth/status',params,false)//前台接口
}
//微信登录
export const wechatLogin = (params: { email?: string, password?: string, wx_auth_code: string})=> {
    return post('/userApi/loginByWechatAuthCode',params,{showErr:false})
}
//获取管理的多个机构后台的列表
export const getAgencyLists = ()=> {
	
	return post('/AgencyApi/getAgencyLists',{})
}
//切换到某个机构去管理
export const switchAgencyManage = (params:{coid:string})=> {
	
	return post('/AgencyApi/switchAgencyManage',params)
}
//切换到某校区
export const switchCampusManage = (params:{campusid:string})=> {
	
	return post('/AgencyApi/switchCampusManage',params)
}
//帮助联系我们
export const contactUs = (params: { description: string, email: string, mobile: string, name: string, organization: string, reqtimestamp: string|number}) => {
    return post('/HelpApi/concatusDemand',params,{showErr:false})
}


